import {
	Chart as ChartComponent,
	type ChartConfig as ChartConfigType
} from './Charts';

export type ChartConfig = ChartConfigType;
export const Chart = ChartComponent;
